var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#085488",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.667 8V6a4.667 4.667 0 0 0-9.334 0v2c0 2.2-2 2.733-2 4 0 1.133 2.6 2 6.667 2s6.667-.867 6.667-2c0-1.267-2-1.8-2-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#085488",
    fillRule: "nonzero",
    d: "M8 15.333c-.674 0-1.307-.022-1.903-.066a1.995 1.995 0 0 0 3.806 0c-.596.044-1.229.066-1.903.066z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a4311eef71ad95f4c3aa04a0177fb1a1.svg";
export { ForwardRef as ReactComponent };